import React from 'react';

const sectors = [
  'Healthcare', 'FinTech', 'Logistics', 'B2B SaaS',
  'PE Portfolio', 'Industrial', 'Telecommunications',
  'Enterprise Ops', 'Healthcare', 'FinTech', 'Logistics',
  'B2B SaaS', 'PE Portfolio', 'Telecommunications',
];

const testimonials = [
  {
    company: 'B2B Operations SaaS',
    quote: 'Nova Terra\'s fractional CTO shipped our MCP-integrated dispatch layer in 8 weeks — our team had estimated 6 months. It\'s now the core of our product.',
    role: 'Chief Executive Officer',
    tag: 'AI-Native Build',
  },
  {
    company: 'Mid-Market PE Portfolio',
    quote: 'Nova Terra cut through vendor noise and aligned the board on a clear modernization path inside two weeks. The 90-day plan held.',
    role: 'Chief Executive Officer',
    tag: 'Tech Assessment',
  },
  {
    company: 'National Healthcare Provider',
    quote: 'They embedded with our team, fixed governance, and shipped an AI pilot on time. Finally an operator who speaks business, technology, and delivery.',
    role: 'Chief Operating Officer',
    tag: 'Program Delivery',
  },
];

const SocialProof = () => {
  return (
    <section id="social-proof" className="bg-white py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-12">
          <div className="space-y-3 max-w-lg">
            <p className="text-[10px] text-emerald-600 uppercase tracking-[0.2em] font-medium">Trusted By</p>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 leading-tight">
              Leaders who needed<br />clarity and momentum.
            </h2>
            <p className="text-slate-500 leading-relaxed">
              We partner with CEOs, COOs, and CTOs across industries who want a senior operator to translate strategy into execution.
            </p>
          </div>
        </div>

        {/* Sector marquee */}
        <div className="relative mb-14">
          {/* Edge fade masks */}
          <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

          <div className="flex gap-3 animate-marquee w-max">
            {[...sectors, ...sectors].map((sector, i) => (
              <span
                key={`${sector}-${i}`}
                className="px-4 py-2 rounded-full border border-slate-200 text-xs text-slate-500 bg-white whitespace-nowrap shadow-sm"
              >
                {sector}
              </span>
            ))}
          </div>
        </div>

        {/* Testimonial cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.company}
              className="group relative bg-white rounded-2xl border border-slate-100 shadow-card hover:shadow-card-hover hover:-translate-y-1.5 hover:border-emerald-200 transition-all duration-300 overflow-hidden"
            >
              {/* Top gradient on hover */}
              <div className="absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <div className="p-7">
                <div className="flex items-center justify-between mb-4">
                  <p className="text-[4rem] leading-none font-serif text-emerald-200 select-none group-hover:text-emerald-300 transition-colors duration-300">"</p>
                  {t.tag && (
                    <span className="text-[10px] px-2.5 py-1 rounded-full bg-em-light border border-em-border text-em-deeper font-semibold uppercase tracking-widest">
                      {t.tag}
                    </span>
                  )}
                </div>

                <p className="text-sm text-slate-600 leading-relaxed mb-6 italic">{t.quote}</p>

                <div className="flex items-center gap-3 pt-4 border-t border-slate-50">
                  <div className="h-8 w-8 rounded-full bg-emerald-50 border border-emerald-100 flex items-center justify-center flex-shrink-0">
                    <div className="h-2 w-2 rounded-full bg-emerald-400" />
                  </div>
                  <div>
                    <p className="text-[10px] text-emerald-600 uppercase tracking-widest font-medium">{t.company}</p>
                    <p className="text-xs text-slate-400 mt-0.5">{t.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default SocialProof;
